import { ExperimentInfo } from '../interfaces'

import ExperimentCard from './ExperimentCard'

type Props = {
  contents: ExperimentInfo[]
  onClickItem: (contentId: string) => void
}

const ExperimentGrid = ({ contents: experiments, onClickItem }: Props) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-6 gap-x-4 sm:gap-x-6">
      {experiments?.map((experiment) => (
        <div
          key={experiment.id}
          onClick={() => onClickItem(experiment.id)}
          className="cursor-pointer"
          tabIndex={0}
        >
          <ExperimentCard
            title={experiment.name}
            createdDate={new Date(experiment.createdDate)}
            users={experiment.contributors}
            contentType={experiment.contentType}
          />
        </div>
      ))}
    </div>
  )
}

export default ExperimentGrid
